import { HttpParams } from '@angular/common/http';
import { NgbDateStruct, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { DatetimeStruct } from './datetime-struct';

export type HttpParamsObj =
  | HttpParams
  | {
      [param: string]: string | number | boolean | readonly (string | number | boolean)[];
    };

// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export function isFunction(x: unknown): x is Function {
  return Object.prototype.toString.call(x) === '[object Function]';
}

export function isString(x: unknown): x is string {
  return Object.prototype.toString.call(x) === '[object String]';
}

export function isObject(x: unknown): x is object {
  return Object.prototype.toString.call(x) === '[object Object]';
}

export function isDate(x: unknown): x is Date {
  return Object.prototype.toString.call(x) === '[object Date]';
}

export function isNumber(x: unknown): x is number {
  return Object.prototype.toString.call(x) === '[object Number]';
}

export function isBoolean(x: unknown): x is boolean {
  return Object.prototype.toString.call(x) === '[object Boolean]';
}

export function isInteger(x: unknown): x is number {
  return isNumber(x) && isFinite(x) && Math.floor(x) === x;
}

export function isNgbDateStruct(x: unknown): x is NgbDateStruct {
  return isObject(x) && 'year' in x && 'month' in x && 'day' in x;
}

export function isNgbTimeStruct(x: unknown): x is NgbTimeStruct {
  return isObject(x) && 'hour' in x && 'minute' in x && 'second' in x;
}

export function isDatetimeStruct(x: unknown): x is DatetimeStruct {
  return isNgbDateStruct(x) && isNgbTimeStruct(x);
}
